import Text from '@/common/components/atom/text';
import { useFilterChange } from '@/modules/search/hooks/useFilterChange';
import { addCommas } from '@persian-tools/persian-tools';

interface RadioFilterProps {
  items: any[];
  name: string;
  title?: string;
  onChange?: (value: any) => void;
}

export const RadioFilter = (props: RadioFilterProps) => {
  const { items, name, title, onChange } = props;
  const { handleChange, filters, goTo } = useFilterChange();

  return (
    // a long neighbourhood list (Tehran has dozens) scrolls inside its own box instead of pushing the other filters away
    <div className={items?.some(item => item.href) && items.length > 12 ? 'flex flex-col space-y-2 max-h-72 overflow-y-auto' : 'flex flex-col space-y-2'}>
      {title && (
        <Text fontWeight="bold" className="mb-1">
          {title}
        </Text>
      )}
      {items?.map(item =>
        item.href ? (
          // DR-43 neighbourhood: a real link (crawlable, opens in a new tab), looks like the other radios, and navigates in-app
          <a
            key={item.value}
            href={item.href}
            className="flex items-center cursor-pointer space-s-2 min-h-[28px]"
            onClick={e => {
              if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
              e.preventDefault();
              goTo(item.href);
              onChange && onChange({ name, value: item.value });
            }}
          >
            <input type="radio" name={name} checked={filters[name] === item.value} readOnly tabIndex={-1} />
            <Text>{item.title}</Text>
            {item.count && (
              <Text fontSize="xs" className="decoration-dotted underline opacity-50">
                {addCommas(item.count ?? 0)}
              </Text>
            )}
          </a>
        ) : (
          <label key={item.title} className="flex items-center cursor-pointer space-s-2">
            <input
              checked={filters[name] === item.value}
              type="radio"
              name={name}
              onChange={e => {
                e.target.checked && handleChange(name, item.value);
                onChange && onChange({ name, value: item.value });
              }}
            />
            <Text>{item.title}</Text>
            {item.count && (
              <Text fontSize="xs" className="decoration-dotted underline opacity-50">
                {addCommas(item.count ?? 0)}
              </Text>
            )}
          </label>
        ),
      )}
    </div>
  );
};

export default RadioFilter;
